import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      function equalizeSlideContentHeights() {
        const slideContents = document.querySelectorAll( '.process-steps__slide-content' );
        slideContents.forEach( ( el ) => el.style.minHeight = '' );
        const maxHeight = Math.max( ...Array.from( slideContents ).map( ( el ) => el.offsetHeight ) );
        slideContents.forEach( ( el ) => el.style.minHeight = `${maxHeight}px` );
      }
      const hasSlideContents = document.querySelectorAll( '.process-steps__slide-content' ).length > 0;
      const debouncedEqualize = hasSlideContents ?
        new app.components.common.Debounce( equalizeSlideContentHeights, 250 ) :
        null;

      if ( $( '.process-steps' ).length ) {
        $( '.process-steps' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            perPage: 2,
            pagination: false,
            perMove: 1,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );
          slider.on( 'overflow', function( isOverflow ) {
            if ( !isOverflow ) {
              slider.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
                clones: isOverflow ? undefined : 0,
                focus: 0,
              };
            }
          } );
          if ( hasSlideContents ) {
            slider.on( 'mounted updated', equalizeSlideContentHeights );
          }
          slider.mount();
        } );

        if ( hasSlideContents ) {
          window.addEventListener( 'resize', () => debouncedEqualize.run() );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'process-steps', COMPONENT );
} )( app );
